import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { LoadingService } from "src/app/services/loading.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes("pesapal") || request.url.includes("life")) {
      return next.handle(request);
    }
    console.log(":::::  INTERCEPT START  :::::");
    this.loadingService.setLoading(true, request.url);
    console.log(":::::  INTERCEPT END  :::::");

    return next.handle(request);
  }
}
